import { render, staticRenderFns } from "./CommonDetailsList.vue?vue&type=template&id=531f1f38&"
import script from "./CommonDetailsList.vue?vue&type=script&lang=js&"
export * from "./CommonDetailsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports